module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_VERLETZUNGEN_hauptseite-hintergrund.75a595c0.jpg";